import {Component, OnInit} from '@angular/core';
import {AuthService} from '@app/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css', '../assets/scss/tooltip.scss']
})
export class AppComponent implements OnInit {

    constructor(private authService: AuthService) {
        //
    }

    async ngOnInit() {
        // Listen for changes in the localstorage. If the user auth token
        // no longer exists, logout the user.
        window.addEventListener('storage', async (ev) => {
            if (ev.storageArea === localStorage) {
                const idToken = await this.authService.getAuthorizationHeader();
                if (idToken === '' || idToken === undefined) {
                    await this.authService.logOut();
                }
            }
        }, false);

        window.addEventListener('unload', (event) => {
            localStorage.removeItem('UserService.authUser');
            this.logUnloadEvent();
        });
    }

    logUnloadEvent() {
        const currentURL = window.location.href;
        // Ignore unload events that aren't "refresh" or "window/tab close"
        // NOTE: We can't differentiate "refresh" vs. "window/tab close" events
        if (!this.ignoreUnloadEvent(currentURL)) {
            this.authService.attemptLogUserUnloadEvent();
        }
        return;
    }

    ignoreUnloadEvent(currentURL) {
        // NOTE: These event "types" could be captured and stored with back-end
        // user access tracking values/datetimes.
        // We could then provide more accurate user activity/access logging
        //
        // No token set for user -> ignore
        // This "unload" event typically occurs on logout
        if (!this.userHasIdToken()) {
            return true;
        }
        // Navigating from Cognito auth callback with access code -> ignore
        // This "unload" event typically occurs on login
        // TODO - Handle Okta scenario
        if (currentURL.includes('/login/cognito-callback?code')) {
            return true;
        }
        return false;
    }

    userHasIdToken() {
        // Simple function to synchronously determine if client
        // currently has an "id token"
        // TODO - Handle Okta scenario
        const idTokenVal = this.authService.getGetCognitoAuthToken();
        if (idTokenVal) {
            return true;
        }
        return false;
    }
}
